'use client';

import type { AnchorHTMLAttributes } from 'react';
import { twMerge as tw } from 'tailwind-merge';

interface LinkButtonSecondaryProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  className?: string;
}

const LinkButtonSecondary = ({ href, className, children, ...props }: LinkButtonSecondaryProps) => {
  return (
    <a
      href={href}
      className={tw(
        'inline-flex items-center justify-center bg-white dark:bg-gray-900 text-gray-800 dark:text-white font-bold py-3.5 px-7 rounded-xl border-2 border-primary-dark dark:border-primary-light transition-all duration-300 no-underline tracking-wide hover:bg-primary-light dark:hover:bg-primary hover:text-[#000000] dark:hover:text-white hover:border-primary-light dark:hover:border-primary hover:-translate-y-1 hover:shadow-lg active:-translate-y-px',
        className,
      )}
      {...props}
    >
      {children}
    </a>
  );
};

export default LinkButtonSecondary;
